import { DisplayText, ProgressBar } from '@superops/ui-design-system';
import React from 'react';
import styled from 'styled-components';
import { Row, getTranslatedText } from '@nile/components';
import { FormattedMessage, injectIntl } from 'react-intl';

const DetailHolderTag = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  min-width: 320px;
  background-color: #f4f5f7;
  padding: 1.5rem;
  border-radius: 10px;
  font-size: 1.2rem;
  color: #000000cc;
  .progress-separator {
    align-items: center;
    justify-content: space-around;
  }
  .w100 {
    width: 100%;
  }
  .w80 {
    width: 80%;
  }
  .fx {
    justify-content: space-between;
  }
  .fw700 {
    font-weight: 700;
  }
  .progressBar {
    flex: 10 1;
  }
  .totalTasks {
    display: flex;
    flex: 2 1;
    justify-content: flex-end;
    font-size: 1.4rem;
  }
  .overDue {
    color: #f40000;
  }
`;

const renderTasks = (completed, total) => {
  return `${completed} / ${total}`;
};

const renderCount = (value, type) => {
  if (!value) {
    return null;
  }
  return `${value} ${type}`;
};

const calculateProgress = (completed, total) => {
  if (!total) {
    return 0;
  }
  return Math.floor((completed / total) * 100);
};

const TaskProgressHolder = ({
  completed,
  total,
  overdue,
  open,
  progress,
  blocked,
  intl,
  onlyProgressBar
}) => {
  const renderMessage = () => {
    if (!overdue && !open && !progress && !blocked) {
      if (completed && total && completed === total) {
        return (
          <div className="noWorkStatus">
            <FormattedMessage id="project.details.tasks.completed" />
          </div>
        );
      }
      return (
        <div className="noWorkStatus">
          <FormattedMessage id="project.details.tasks.yetTo" />
        </div>
      );
    }
    return null;
  };

  if (onlyProgressBar) {
    return (
      <Row gap={5} className="nowrap items-center full-width">
        <div className="wp-80">
          <ProgressBar
            progress={calculateProgress(completed, total)}
            size="small"
          />
        </div>
        <DisplayText element="span" size="medium" weight="Bold">
          {renderTasks(completed, total)}
        </DisplayText>
      </Row>
    );
  }

  return (
    <DetailHolderTag className={overdue > 0 ? 'overDueProgress' : null}>
      <div className="fx w80 g10">
        {overdue > 0 && (
          <div className="overDue">
            {renderCount(
              overdue,
              getTranslatedText(intl, 'project.task.status.overdue')
            )}
          </div>
        )}
        {open > 0 && (
          <div>
            {renderCount(
              open,
              getTranslatedText(intl, 'project.task.status.planned')
            )}
          </div>
        )}
        {progress > 0 && (
          <div>
            {renderCount(
              progress,
              getTranslatedText(intl, 'project.task.status.inProgress')
            )}
          </div>
        )}
        {blocked > 0 && (
          <div>
            {renderCount(
              blocked,
              getTranslatedText(intl, 'project.task.status.blocked')
            )}
          </div>
        )}
        {renderMessage()}
      </div>
      <div className="fx w100 progress-separator">
        <div className="progressBar">
          <ProgressBar
            progress={calculateProgress(completed, total)}
            size="small"
          />
        </div>
        <div className="fw700 totalTasks">{renderTasks(completed, total)}</div>
      </div>
    </DetailHolderTag>
  );
};

export default injectIntl(TaskProgressHolder);
